import { coercedDate } from '../../../utils/coerced-date';
import { z } from 'zod/v4';

export const messageHistorySchema = z.object({
  messageId: z.string(),
  accountId: z.number(),
  userId: z.string(),
  deviceId: z.string().nullable(),
  messageType: z.string(),
  sentTimestamp: coercedDate.nullable(),
  acknowledgedTimestamp: coercedDate.nullable(),
  messageBody: z
    .object({
      keytest1: z.string().nullable().optional(),
    })
    .nullable(),
});

export type MessageHistory = z.infer<typeof messageHistorySchema>;
